var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "mb-5 last:mb-0" }, [
    _c(
      "label",
      {
        staticClass: "mb-2 relative vpf-checkbox outline-none",
        attrs: { tabindex: "0", role: "checkbox", "aria-describedby": _vm.id },
        on: {
          keyup: function($event) {
            if (
              !$event.type.indexOf("key") &&
              _vm._k($event.keyCode, "space", 32, $event.key, [" ", "Spacebar"])
            ) {
              return null
            }
            _vm.model.consent = !_vm.model.consent
          }
        }
      },
      [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.model.consent,
              expression: "model.consent"
            }
          ],
          staticClass: "hidden",
          attrs: { type: "checkbox", required: _vm.isRequired },
          domProps: {
            checked: Array.isArray(_vm.model.consent)
              ? _vm._i(_vm.model.consent, null) > -1
              : _vm.model.consent
          },
          on: {
            blur: function($event) {
              return _vm.handleValidation({ isBlur: true })
            },
            change: [
              function($event) {
                var $$a = _vm.model.consent,
                  $$el = $event.target,
                  $$c = $$el.checked ? true : false
                if (Array.isArray($$a)) {
                  var $$v = null,
                    $$i = _vm._i($$a, $$v)
                  if ($$el.checked) {
                    $$i < 0 && _vm.$set(_vm.model, "consent", $$a.concat([$$v]))
                  } else {
                    $$i > -1 &&
                      _vm.$set(
                        _vm.model,
                        "consent",
                        $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                      )
                  }
                } else {
                  _vm.$set(_vm.model, "consent", $$c)
                }
              },
              function($event) {
                return _vm.handleValidation()
              }
            ],
            input: function($event) {
              return _vm.handleInput(!_vm.model.consent)
            }
          }
        }),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass:
              "\n        vpf-checkbox__checkmark\n        h-6\n        w-6\n        border\n        absolute\n        -top-px\n        left-0\n        flex\n        items-center\n        justify-center\n        text-velux-red\n        cursor-pointer\n        z-10\n      ",
            class: _vm.hasError() ? "border-velux-red" : "border-velux-grey-300"
          },
          [
            _vm.model.consent
              ? _c("span", [_c("i", { staticClass: "far fa-check" })])
              : _vm._e()
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass:
              "text-editor pt-0.5 md:pt-0 pl-9 text-editor text-sm md:text-base",
            attrs: { id: _vm.id }
          },
          [
            _vm._t("default"),
            _vm._v(" "),
            _vm.isRequired
              ? _c("span", { staticClass: "text-velux-red ml-0.5" }, [
                  _vm._v("*")
                ])
              : _vm._e()
          ],
          2
        ),
        _vm._v(" "),
        _vm.hasError() && _vm.errorMessage
          ? _c(
              "div",
              {
                staticClass:
                  "pl-9 text-velux-red mt-1 font-bold text-left text-base"
              },
              [_vm._v("\n      " + _vm._s(_vm.errorMessage) + "\n    ")]
            )
          : _vm._e()
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }